import { render, staticRenderFns } from "./UrunDetayModal.vue?vue&type=template&id=320fd874"
import script from "./UrunDetayModal.vue?vue&type=script&lang=js"
export * from "./UrunDetayModal.vue?vue&type=script&lang=js"
import style0 from "./UrunDetayModal.vue?vue&type=style&index=0&id=320fd874&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports